import React, {useState} from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Alert from '@mui/material/Alert';
import {AspectRatioSharp,ImageAspectRatioSharp,Close,Check} from '@mui/icons-material';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import pdfIcon from '../assets/img/pdf.svg';
import Strings from "../assets/strings";
import {hasPermissionTo, PERSMISOS_USUARIOS} from "../helpers";
const useStyles = makeStyles(theme => ({
    groupImg:{
        "display": "flex",
        overflow: "hidden",
        "&>div":{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "border": "1px solid #e9ecef",
            "position": "relative",
            "width": "105px",
            "height": "105px",
            "margin": "5px",
            "& img":{
                width:"100%",
            },
            "& .delete":{
                "fontSize": "21px",
                "position": "absolute",
                "right": "0",
                "top": "0",
                "cursor": "pointer",
                "color": "#f64a4a",
                "background": "#fff",
                "width": "40px",
                "height": "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1,
                "textAlign": "center",
                "WebkitTransition": "opacity .2s",
                "transition": "opacity .2s",
            },
            "&.deleted img":{
                opacity: .3,
            },
            "&.pdf img":{
                maxWidth: 66,
            }

        }
    },
    dialogContent:{
        padding: "3px !important",

    },
    dialogActions:{
        display:"flex",
        "& button:first-child":{
            marginRight: "auto",
        }
    }
}));


export default function AddAdjuntos({adjuntos=[], onChange, changeRadio = true,accept="image/gif, image/jpeg, image/png, application/pdf"}){
    const classes = useStyles();

    const [img, setImg] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [aspectRatioSq, setAspectRatioSq] = useState(true);
    const [cropper, setCropper] = useState(React.createRef(null));

    const showModal = () => {
        setShowAddForm(true)
    }
    const closeModal = () => {
        setLoading(false)
        setShowAddForm(false)
    }
    const handleChange = e => {
        e.preventDefault();
        setError(null);
        let file;
        if (e.dataTransfer) {
            file = e.dataTransfer.files[0];
        } else if (e.target) {
            file = e.target.files[0];
        }
        if (!file) return false;
        if(file.type.indexOf("image") === -1 && file.type.indexOf("pdf") === -1) return setError(Strings.archivoNoPermitidoMsj)

        if(file.type.indexOf("pdf") !== -1 && file.size > 2000000) return setError(Strings.archivoExcedeMsj+ ", 2MB!");

        const reader = new FileReader();
        reader.onload = () => {
            if(file.type.indexOf("image") !== -1){
                setImg(reader.result);
                showModal()
            }else{
                let adj = adjuntos;
                adj.push({ arcExtension: "pdf", arcBase64: reader.result})
                onChange(adj);
            }
        };
        reader.readAsDataURL(file);

    }
    const cropImage = e => {
        e.preventDefault();
        if(loading) return false;

        setLoading(true)

        if (typeof cropper.getCroppedCanvas() === 'undefined') {
            return;
        }

        let adj = adjuntos;
        let arcBase64 = cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8);

        adj.push({ arcExtension: "jpeg", arcBase64});



        onChange(adj);
        closeModal();
    }
    const delAdjunto = (index)  =>{


        let adj = adjuntos;
        if (adj[index].arcBase64 === null){
            adj[index].arcBase64 = "-1";
        } else if (adj[index].arcBase64 === "-1") {
            adj[index].arcBase64 = null
        }else{
            adj.splice(index, 1)
        }
        onChange(adj);



        // if(src && src.toString().length < 100 && src !== -1){
        //     setDeleted(src);
        //     onChange(-1)
        // }else{
        //     onChange(deleted)
        // }
    }

    return (
        <>
            <div className="contAdjuntos">
                <Box display='flex' alignItems="center" bgcolor={"#ececec"} p={"0 5px"}>
                    <Typography sx={{flex: '1 1 100%'}} variant="body1" color={"secondary"}>{Strings.adjuntos}</Typography>
                        <Button color={"primary"} component={"label"} disabled={adjuntos?.length >= 5 || !hasPermissionTo(PERSMISOS_USUARIOS.documentos)}>
                            {Strings.agregar}
                            {hasPermissionTo(PERSMISOS_USUARIOS.documentos) &&
                                <input type="file" style={{display:"none"}} onChange={handleChange} accept={accept} capture="user"/>
                            }
                        </Button>
                </Box>
                {!!error && <Alert onClose={() => setError(null)} severity="warning">{error}</Alert>}
                <div className={classes.groupImg}>
                        {adjuntos?.length > 0 && adjuntos.map((adjunto, i) =>
                            <div key={i} className={(adjunto.arcExtension === "pdf" ? 'pdf' : 'img') + (adjunto.arcBase64 === "-1" ? ' deleted' : '') }>
                                <div className="delete" onClick={() => delAdjunto(i)}>{adjunto.arcBase64 === "-1" ? <Check color={"primary"}/> : <Close/>}</div>
                                <a href={adjunto.arcPath ? adjunto.arcPath.replace("-small", ""):null} target="_blank" rel="noopener noreferrer">
                                    <img src={adjunto.arcExtension === "pdf" ? pdfIcon : (adjunto.arcPath ? adjunto.arcPath : adjunto.arcBase64)} alt=""  />
                                </a>
                            </div>)
                        }
                    </div>
            </div>
            <Dialog open={Boolean(showAddForm)} onClose={closeModal}>
                <DialogContent className={classes.dialogContent}>
                    <Cropper
                        style={{ height: 400, width: '100%' }}
                        aspectRatio={aspectRatioSq ? 1 : null}
                        guides={false}
                        viewMode={0}
                        src={img}
                        ref={cropper => setCropper(cropper)}
                    />
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    {changeRadio &&
                    <Button color="primary" onClick={() => setAspectRatioSq(!aspectRatioSq)}>
                        {aspectRatioSq ?(<AspectRatioSharp/>):(<ImageAspectRatioSharp color={"secondary"}/>)}
                    </Button>
                    }
                    <Button color="primary" onClick={closeModal}>{Strings.cerrar}</Button>
                    <Button
                        color="primary"
                        disabled={loading}
                        onClick={!loading ? cropImage : null} >
                        {loading ? Strings.cargando : Strings.agregar}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
